import styled from "styled-components";

export const MainContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 32px 40px;
  @media (max-width: 1024px) {
    padding: 24px 20px;
  }
  @media (max-width: 640px) {
    padding: 20px 12px;
  }
`;

export const MainHeader = styled.div`
  margin-bottom: 24px;
`;

export const MainHeading = styled.h2`
  margin: 0 0 4px;
  color: #111;
  font-family: "Syne", sans-serif;
  font-size: 24px;
  font-weight: 800;
  @media (max-width: 640px) {
    font-size: 22px;
  }
`;

export const MainSubHeading = styled.p`
  margin: 0;
  color: #9ca3af;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 300;
`;

export const SummaryBar = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  margin-bottom: 20px;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (max-width: 760px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const SummaryCard = styled.div`
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  padding: 14px 16px;
  position: relative;
  overflow: hidden;
  .top {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
  }
  .top.orange {
    background: #e8521a;
  }
  .top.green {
    background: #16a34a;
  }
  .top.blue {
    background: #1d4ed8;
  }
  .top.amber {
    background: #f59e0b;
  }
  .top.red {
    background: #dc2626;
  }
`;

export const SummaryLabel = styled.div`
  font-size: 10px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  font-weight: 500;
`;

export const SummaryValue = styled.div`
  font-family: "Syne", sans-serif;
  font-size: 22px;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 3px;
  color: ${(p) => p.$color || "#111"};
`;

export const SummarySub = styled.div`
  font-size: 10px;
  color: #9ca3af;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 10px;
  padding: 12px 16px;
  @media (max-width: 960px) {
    flex-direction: column;
    align-items: stretch;
  }
  @media (max-width: 640px) {
    padding: 10px;
  }
`;

export const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  flex-wrap: wrap;
  @media (max-width: 640px) {
    gap: 8px;
  }
`;

export const SearchWrap = styled.div`
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  padding: 7px 12px;
  min-width: 240px;
  flex: 1 1 280px;
  @media (max-width: 640px) {
    min-width: 100%;
    flex-basis: 100%;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  font-family: "Inter", sans-serif;
  color: #111;
`;

export const FilterSelect = styled.select`
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
  border-radius: 7px;
  padding: 7px 10px;
  font-size: 12px;
  color: #374151;
  font-family: "Inter", sans-serif;
  outline: none;
  min-height: 32px;
  @media (max-width: 640px) {
    flex: 1 1 calc(50% - 6px);
    min-width: 0;
  }
  @media (max-width: 420px) {
    flex-basis: 100%;
  }
`;

export const ToolbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  @media (max-width: 960px) {
    justify-content: space-between;
    width: 100%;
  }
  @media (max-width: 640px) {
    flex-wrap: wrap;
  }
`;

export const BulkActions = styled.div`
  display: ${(p) => (p.$visible ? "flex" : "none")};
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: #fff0eb;
  border: 1px solid #fdd0c0;
  border-radius: 7px;
  font-size: 11px;
  color: #e8521a;
  font-weight: 500;
  @media (max-width: 640px) {
    width: 100%;
    flex-wrap: wrap;
  }
`;

export const BulkBtn = styled.button`
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  &.primary {
    background: #e8521a;
    color: #fff;
  }
  &.outline {
    background: transparent;
    color: #e8521a;
    border: 1px solid #e8521a;
  }
  &.danger {
    background: #dc2626;
    color: #fff;
  }
`;

export const ActionBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 30px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid transparent;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease,
    box-shadow 0.15s ease;

  background: #fff;
  color: #374151;
  border-color: #e5e7eb;

  &:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #d1d5db;
  }

  &.primary {
    background: #e8521a;
    color: #fff;
    border-color: #e8521a;
    box-shadow: 0 1px 2px rgba(232, 82, 26, 0.25);

    &:hover:not(:disabled) {
      background: #d44816;
      border-color: #d44816;
      color: #fff;
    }
  }

  &.danger {
    background: #fff;
    color: #dc2626;
    border-color: #fecaca;

    &:hover:not(:disabled) {
      background: #fef2f2;
      border-color: #fca5a5;
      color: #b91c1c;
    }
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    box-shadow: none;
  }

  @media (max-width: 640px) {
    height: 32px;
    font-size: 12px;
    padding: 0 10px;
  }
`;

export const ActionGroup = styled.div`
  display: grid;
  grid-template-columns: 84px 72px;
  gap: 8px;
  align-items: center;
  width: max-content;

  ${ActionBtn} {
    width: 100%;
    padding: 0 8px;
  }
`;

export const TableContainer = styled.div`
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 12px;
  max-width: 100%;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
`;

export const TableRoot = styled.table`
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
  thead tr {
    background: #f9f9f9;
    border-bottom: 1px solid #f0f0f0;
  }
  th {
    padding: 11px 14px;
    font-size: 10px;
    font-weight: 600;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-align: left;
  }
  td {
    padding: 12px 14px;
    font-size: 13px;
    color: #374151;
    border-bottom: 1px solid #f9f9f9;
    vertical-align: middle;
  }
  tbody tr.selected td {
    background: #fff8f5;
  }
`;

export const Checkbox = styled.input`
  width: 15px;
  height: 15px;
  accent-color: #e8521a;
`;

export const ProductCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ProductThumb = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid #ebebeb;
  background: ${(p) => (p.$img ? `url(${p.$img}) center/cover no-repeat` : "#f5f5f5")};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProductName = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #111;
  max-width: 190px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProductId = styled.div`
  font-size: 10px;
  color: #9ca3af;
`;

export const MarketplaceBadge = styled.span`
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1e3a8a;
`;

export const SupplierCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const SupplierName = styled.div`
  font-size: 11px;
  color: #374151;
  font-weight: 500;
`;

export const TrackingCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TrackingNum = styled.div`
  font-size: 11px;
  color: #9ca3af;
`;

export const TrackStep = styled.span`
  display: inline-block;
  width: 18px;
  height: 3px;
  margin-right: 2px;
  border-radius: 999px;
  background: ${(p) => (p.$active ? "#16a34a" : "#e5e7eb")};
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  font-weight: 600;
  padding: 4px 9px;
  border-radius: 999px;
  background: ${(p) => p.$bg};
  color: ${(p) => p.$color};
`;

export const StatusDot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: ${(p) => p.$dot};
`;

export const AmountCell = styled.span`
  font-family: "Syne", sans-serif;
  font-weight: 700;
  font-size: 13px;
`;

export const PaginationWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-top: 1px solid #f0f0f0;
  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

export const PageInfo = styled.div`
  font-size: 12px;
  color: #9ca3af;
`;

export const PageButtons = styled.div`
  display: flex;
  gap: 4px;
`;

export const PageButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  background: ${(p) => (p.$active ? "#E8521A" : "#fff")};
  color: ${(p) => (p.$active ? "#fff" : "#374151")};
  cursor: pointer;
`;

export const EmptyState = styled.div`
  padding: 72px 24px;
  text-align: center;
`;

export const EmptyIcon = styled.div`
  width: 72px;
  height: 72px;
  background: #f5f5f5;
  border-radius: 18px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
`;

export const EmptyTitle = styled.div`
  font-family: "Syne", sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #111;
  margin-bottom: 8px;
`;

export const EmptySub = styled.div`
  font-size: 13px;
  color: #9ca3af;
  margin-bottom: 22px;
`;

export const EmptyCta = styled.button`
  background: #e8521a;
  color: #fff;
  border: none;
  padding: 11px 24px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;
